export const IBARAKI_REGION_ROUTE = 'ibaraki-region';
export const IBARAKI_REGION_DOMAIN = 'event.kenou-ibaraki.site';
